import { FieldError } from "@/components/form/ConfigField";

const guideState = (n, [lo, hi]) => (n === 0 ? "vuoto" : n < lo ? "un po' corto" : n > hi ? "troppo lungo" : "lunghezza ideale");

export const Guide = ({ id, text, range, label = "" }) => (
    <p id={id} aria-live="polite" className={`text-sm ${text.length > range[1] ? "text-edi-error font-semibold" : "text-edi-muted"}`} data-testid={id}>
        {label}{text.length} caratteri · consigliati {range[0]}–{range[1]} · {guideState(text.length, range)}
    </p>
);

export const Note = ({ testId }) => (
    <p className="rounded-lg border-l-4 border-edi-lime bg-edi-bg px-3 py-2 text-sm font-semibold" data-testid={testId}>
        Queste impostazioni si applicano al sito pubblicato alla prossima pubblicazione
    </p>
);

export const SeoInput = ({ id, f, value, onChange, error, readOnly, guide }) => {
    if (f.type === "switch") {
        return (
            <div className="flex items-start gap-3">
                <input id={id} type="checkbox" role="switch" className="mt-1 h-5 w-5 accent-[var(--edi-primary)]" checked={!!value} disabled={readOnly}
                    onChange={(e) => onChange(e.target.checked)} aria-describedby={f.hint ? `${id}-hint` : undefined} data-testid={`${id}-switch`} />
                <div>
                    <label htmlFor={id} className="font-semibold">{f.label}</label>
                    {f.hint && <p id={`${id}-hint`} className="text-sm text-edi-muted">{f.hint}</p>}
                </div>
            </div>
        );
    }
    const Tag = f.type === "textarea" ? "textarea" : f.type === "select" ? "select" : "input";
    const describedBy = [f.hint && `${id}-hint`, guide && `${id}-guide`, error && `${id}-error`].filter(Boolean).join(" ") || undefined;
    return (
        <div className="space-y-1 min-w-0">
            <label htmlFor={id} className="edi-label">{f.label}{f.required && <span aria-hidden="true"> *</span>}</label>
            {f.hint && <p id={`${id}-hint`} className="text-sm text-edi-muted break-words">{f.hint}</p>}
            <Tag id={id} className="edi-input" value={value ?? ""} readOnly={Tag !== "select" ? readOnly : undefined} disabled={Tag === "select" ? readOnly : undefined}
                rows={Tag === "textarea" ? 3 : undefined} type={f.type === "url" ? "url" : f.type === "email" ? "email" : undefined}
                inputMode={f.type === "url" ? "url" : undefined} placeholder={f.placeholder} aria-required={f.required ? "true" : undefined}
                onChange={(e) => onChange(e.target.value)} aria-invalid={error ? "true" : "false"} aria-describedby={describedBy} data-testid={`${id}-input`}>
                {f.options?.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
            </Tag>
            {guide}
            <FieldError id={`${id}-error`} error={error} />
        </div>
    );
};

const host = (url) => { try { return new URL(url).host; } catch (e) { return url; } };

export const GooglePreview = ({ title, url, description }) => (
    <figure className="rounded-xl border border-edi-border bg-white p-4 min-w-0" data-testid="seo-google-preview">
        <figcaption className="text-xs font-semibold uppercase tracking-wide text-edi-muted mb-2">Anteprima risultato Google</figcaption>
        <p className="text-sm text-[#202124] break-all">{host(url)} › {url.replace(/^https?:\/\/[^/]+/, "") || "/"}</p>
        <p className="text-xl text-[#1a0dab] leading-snug break-words" data-testid="seo-google-title">{title.length > 60 ? `${title.slice(0, 59)}…` : title}</p>
        <p className="text-sm text-[#4d5156] break-words" data-testid="seo-google-description">{description.length > 160 ? `${description.slice(0, 159)}…` : description}</p>
    </figure>
);

export const SocialPreview = ({ image, url, title, description }) => (
    <figure className="rounded-xl border border-edi-border bg-white overflow-hidden min-w-0" data-testid="seo-social-preview">
        <figcaption className="text-xs font-semibold uppercase tracking-wide text-edi-muted px-4 pt-3 pb-2">Anteprima condivisione social</figcaption>
        <img src={image} alt="" className="w-full aspect-[1.91/1] object-cover bg-edi-bg" data-testid="seo-social-image" />
        <div className="bg-[#f0f2f5] px-4 py-3">
            <p className="text-xs uppercase text-[#4b4f56] break-all">{host(url)}</p>
            <p className="font-bold text-[#1d2129] break-words" data-testid="seo-social-title">{title}</p>
            <p className="text-sm text-[#4b4f56] break-words line-clamp-2">{description}</p>
        </div>
    </figure>
);
